//高負荷か。

import { atom } from 'recoil';

export const galleryRoundedIndex = atom({
  key: 'galleryRoundedIndex',
  default: 0,
});
